import { NgModule, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { App } from './app';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { APICallerService, SpinnerComponent, GlobalErrorHandlerService } from '@org/ui-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieModule } from 'ngx-cookie';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { authInterceptor, AUTH_INTERCEPTOR_CONFIG } from '@org/ui-common';  
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    App
],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    ReactiveFormsModule,
    CookieModule.forRoot(),
    SpinnerComponent
  ],
  providers: [
    provideZoneChangeDetection(),
    {
        provide: ErrorHandler,
        useClass: GlobalErrorHandlerService
    },
    {
      provide: AUTH_INTERCEPTOR_CONFIG,
      useValue: {
          appName: 'web-partnerportal',
          authUsername: environment.authUsername,
          authPassword: environment.authPassword,
          loginUrlPattern: 'way-auth/auth/login',
          insurancePathPatterns: ['/insurance-steps', '/auto-insurance', '/ai', '/insurance-pay']
      }
    },
    provideHttpClient(withInterceptors([authInterceptor])),
    NgbActiveModal,
    APICallerService,
    provideBrowserGlobalErrorListeners()
] ,
  bootstrap: [App],
})
export class AppModule {}